export default __webpack_public_path__ + "static/assets/165acba7399c4792dd61d9e94cd45b04.png";